import React from 'react';

import Quicks from '../components/quicks';
import Journals from '../components/journals';
import Conferences from '../components/conferences';
import Patents from '../components/patents';
import BookChapters from '../components/book-chapters';
import Preprints from '../components/preprints';

const Component = () => {
    return (
        <div>
            <Quicks
                external
                links={[]}
                navs={[
                    { name: 'Journals', link: '#Journals' },
                    { name: 'Conferences', link: '#Conferences' },
                    { name: 'Book Chapters', link: '#BookChapters' },
                    { name: 'Patents', link: '#Patents' },
                    { name: 'Preprints', link: '#Preprints' }
                ]}
            />

            <Journals />
            <Conferences />
            <BookChapters />
            <Patents />
            <Preprints />
        </div>
    );
};

export default Component;
